import React, { useState } from 'react';
import ExchangeQuestions from './QuestionList';


const QuestionListing = () => { 
  return (
    <div>
     <ExchangeQuestions title={"question"} />
    </div>
  );
};

export default QuestionListing;
